import { render, staticRenderFns } from "./TaskCardHeader.vue?vue&type=template&id=73826c97&scoped=true&"
import script from "./TaskCardHeader.vue?vue&type=script&lang=ts&"
export * from "./TaskCardHeader.vue?vue&type=script&lang=ts&"
import style0 from "./TaskCardHeader.vue?vue&type=style&index=0&id=73826c97&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73826c97",
  null
  
)

export default component.exports